import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CompanyCollectorService } from '@core/services/entities/company-collector.service';
import { CompanyCollectorRepository } from '@domain/company-collector/repositories/company-collector.repository';
import { CompanyCollectorModel } from '@domain/company-collector/models/company-collector.model';
import { ListCompanyCollectorRequestDto } from '@domain/company-collector/dtos/list-company-collector.request.dto';
import { CreateCompanyCollectorRequestDto } from '@domain/company-collector/dtos/create-company-collector.request.dto';
import { UpdateStateCompanyCollectorRequestDto } from '@domain/company-collector/dtos/update-state-company-collector.request.dto';
import { RefId } from '@core/interface/ref-id.interface';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { CompanyCollectorMapper } from '@domain/company-collector/mappers/company-collector.mapper';
import { CompanyCollectorAdditionalChargeResponseDto } from '@domain/company-collector/dtos/company-collector-additional-charge.response.dto';
import { UpdateCompanyCollectorAdditionalChargeRequestDto } from '@domain/company-collector/dtos/update-company-collector-additional-charge.request.dto';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorRepositoryService
  implements CompanyCollectorRepository
{
  constructor(
    private companyCollectorService: CompanyCollectorService,
    private mapper: CompanyCollectorMapper,
  ) {}

  create(
    request: CreateCompanyCollectorRequestDto,
  ): Observable<ApiResponse<CompanyCollectorModel>> {
    return this.companyCollectorService.create(request).pipe(
      map((response) => {
        return {
          ...response,
          data: this.mapper.mapDtoToModel(response.data),
        };
      }),
    );
  }

  show(request: RefId): Observable<CompanyCollectorModel> {
    return this.companyCollectorService.show(request).pipe(
      map((response) => {
        return this.mapper.mapDtoToModel(response.data);
      }),
    );
  }

  list(
    request: ListCompanyCollectorRequestDto,
  ): Observable<PageableResponse<CompanyCollectorModel>> {
    return this.companyCollectorService.list(request).pipe(
      map((response) => {
        return this.mapper.mapPageableDtoToModel(response.data);
      }),
    );
  }

  updateState(
    request: UpdateStateCompanyCollectorRequestDto,
  ): Observable<CompanyCollectorModel> {
    return this.companyCollectorService.updateState(request).pipe(
      map((response) => {
        return this.mapper.mapDtoToModel(response.data);
      }),
    );
  }

  showAdditionalCharges(
    request: RefId,
  ): Observable<CompanyCollectorAdditionalChargeResponseDto> {
    return this.companyCollectorService
      .showAdditionalCharges(request)
      .pipe(map((response) => response.data));
  }

  updateAdditionalCharges(
    request: UpdateCompanyCollectorAdditionalChargeRequestDto,
  ): Observable<ApiResponse<CompanyCollectorAdditionalChargeResponseDto>> {
    return this.companyCollectorService.updateAdditionalCharges(request);
  }
}
